import React, { useRef, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { calendarUpdateAction, selectCalendarDateAction, focusDayAction } from 'redux/reducers/calendar/actions'
import { formattedDay, yearMonthDay, isSelected } from 'redux/reducers/calendar/utls.js'

const Day = ({ day, t, i18n }) => {
  const dispatch = useDispatch()
  const { today, selected, focusedDayNum, isBlockedDay, firstAvailableDate, lastAvailableDate, availableDates } = useSelector(
    (state) => state.calendar
  )
  const { $D: dayNum = 0 } = day
  const { $D: todayDayNum = 0 } = today
  const tabIndex = dayNum !== todayDayNum ? { tabIndex: -1 } : {}
  const isDisabled = isBlockedDay(day, firstAvailableDate, lastAvailableDate, availableDates)
  const isCurrent = day.isSame(today)
  const formattedDate = yearMonthDay(day)
  const pressed = isSelected(selected, formattedDate)
  const bthState = isDisabled ? 'Calendar-item--unavailable' : 'Calendar-item--active'
  const currentState = isCurrent ? { 'aria-current': 'date' } : {}
  const labelDate = formattedDay(day, i18n.language === "fr")
  const inputEl = useRef(null)
  const label = isDisabled ? `${t('calendar_schedular_unavailable')}, ${labelDate}` : labelDate

  useEffect(() => {
    if (Number(dayNum) === Number(focusedDayNum)) {
      inputEl.current.focus()
    }
  }, [focusedDayNum, dayNum])

  return (
    <button
      ref={inputEl}
      type="button"
      aria-label={label}
      aria-pressed={pressed === -1 ? false : true}
      className={['Calendar-item', bthState].join(' ')}
      data-timestamp={day.unix()}
      data-day={`${dayNum}`}
      data-date={formattedDate}
      onFocus={(event) => {
        const focused = event.currentTarget.dataset['day']
        // const date = event.currentTarget.dataset['date']
        if (Number(focusedDayNum) !== Number(focused)) {
          dispatch(focusDayAction(focused))
        }
      }}
      onClick={() => {
        dispatch(selectCalendarDateAction(yearMonthDay(day)))
        dispatch(calendarUpdateAction(`selected ${label}`))
      }}
      {...currentState}
      {...tabIndex}
    >
      {dayNum}
    </button>
  )
}

export default withTranslation('common')(Day)
